import React, { Component } from 'react'
import StickyMove from './StickyMove'
import Alert from '../etc/Alert'
import Updater from '../../controller/Updater'
import Deleter from '../../controller/Deleter'


export default class StickyNote extends Component {

    constructor(props) {
        super(props)
        this.state = {
            isMove: false,
            txt: this.props.txt,
            posX: this.props.posX,
            posY: this.props.posY,
            isAlert: false
        }
    }

    componentDidMount() {

        if(this.props.isMobile) {
            document.getElementById(this.props.idName).style.transform = 'translate3d( 3px,' 
            + this.props.posY + 'px, 0'
            
        } else {
            document.getElementById(this.props.idName).style.transform = 'translate3d(' + this.props.posX + 'px,' 
            + this.props.posY + 'px, 0'
        }
    }

    changeFx = (e) => {

        e.preventDefault()
        
        this.setState(
            { [e.target.name] : e.target.value }
        )
    }

    postFx = () => {

        let condition = {
            url : '/api/sticky/update/' + this.props.idName,
            data : this.state.txt
        }
        
        Updater(condition, res => {

            if(res.data === 'blocked') {
                this.setState({ isAlert : true})
                return
            }

        })

    }

    removeFx = () => {

        let condition = {
            url : '/api/sticky/delete/' + this.props.idName
        }

        Deleter(condition, res => {

            if(res.data === 'blocked') {
                this.setState({ isAlert : true})
                return
            }

        })

    }

    moveFx = () => {

        this.setState( { isMove: true } )
        document.getElementById(this.props.idName).style.opacity = 0.5
    }

    cbackFx = (poo, bar) => {

        this.setState({
            isMove : false,
            posX : poo,
            posY : bar
        })

        const targetX = document.getElementById(this.props.idName)

        targetX.style.WebkitTransition = 'transform 1s';
        targetX.style.MozTransition = 'transform 1s';
        targetX.style.opacity = 1
        targetX.style.transform = 'translate3d(' + poo + 'px,' + bar + 'px, 0'

        let condition = {
            url : '/api/sticky/update/' + this.props.idName,
            data : {
                posX: poo,
                posY: bar
            }
        }

        Updater(condition, res => {

            if(res.data === 'blocked') {
                this.setState({ isAlert : true})
                return
            }

        })
    }

    closeFx = () => {
        this.setState({
            isAlert : false
        })
    }


    render() {

        return (

            <React.Fragment>

                {this.state.isAlert ? <Alert alert = 'Access Denied' closeMe = {this.closeFx} /> : null} 
         
                <div className='StickyNote'  id={this.props.idName}>

                    <div className='StickyHead'>
                        <i className='material-icons' style={{left: 0}} onClick={this.moveFx}>zoom_out_map</i>
                        <i className='material-icons' style={{right: 0}} onClick={this.removeFx}>close</i>
                    </div>

                    <textarea name='txt' value={this.state.txt} onChange={this.changeFx} onBlur={this.postFx}></textarea>

                </div>

                {this.state.isMove ? <StickyMove cback={this.cbackFx} /> : null }

            </React.Fragment>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/sticky/StickyNote.js